import React, { FC, useCallback, useState } from 'react';
import styled from 'styled-components/native';

import { EDataTestId } from '@webtrader/core/constants/test';
import { useTranslation } from '@webtrader/core/i18n';
import storage, { EStorageKey } from '@webtrader/core/storage';

import Checkbox from '@/components/Checkbox';
import Text from '@/components/Text';

interface IRememberMeProps {}

const RememberMe: FC<IRememberMeProps> = () => {
  const { t } = useTranslation();
  const rememberMe = storage.getItem(EStorageKey.REMEMBER_ME) as boolean;

  const [remember, setRemember] = useState(rememberMe ?? false);

  const onCheck = useCallback(() => {
    const value = !remember;
    setRemember(value);
    storage.setItem(EStorageKey.REMEMBER_ME, value);
  }, [remember]);

  return (
    <StyledContainer>
      <Checkbox
        checked={remember}
        onCheck={() => onCheck()}
        testID={remember ? EDataTestId.LOGIN_REMEMBER_ME_CHECKED : EDataTestId.LOGIN_REMEMBER_ME_UNCHECKED}
      >
        <StyledCheckboxText>{t('Remember me')}</StyledCheckboxText>
      </Checkbox>
    </StyledContainer>
  );
};

export default RememberMe;

const StyledContainer = styled.View`
  flex-direction: row;
  display: flex;
  align-items: center;
`;

const StyledCheckboxText = styled(Text)``;
